export const ADDRESS_TYPE_CHOICES = [
    { key: 'ALTO', label: 'Alto' },
    { key: 'ALVEO', label: 'Alveo' },
    { key: 'ALZAIA', label: 'Alzaia' },
    { key: 'ANDRONA', label: 'Androna' },
    { key: 'ANGIPORTO', label: 'Angiporto' },
    { key: 'ANGOLO', label: 'Angolo' },
    { key: 'ARCO', label: 'Arco' },
    { key: 'AUTOSTRADA', label: 'Autostrada' },
    { key: 'BAIA', label: 'Baia' },
    { key: 'BALUARDO', label: 'Baluardo' },
    { key: 'BANCHINA', label: 'Banchina' },
    { key: 'BARBARIA', label: 'Barbaria' },
    { key: 'BASTIONI', label: 'Bastioni' },
    { key: 'BIRI', label: 'Biri' },
    { key: 'BIVIO', label: 'Bivio' },
    { key: 'BOCCA DE', label: 'Bocca de' },
    { key: 'BORGATA', label: 'Borgata' },
    { key: 'BORGO', label: 'Borgo' },
    { key: 'BORGOLOCO', label: 'Borgoloco' },
    { key: 'BRIGATA', label: 'Brigata' },
    { key: 'CALATA', label: 'Calata' },
    { key: 'CALLE', label: 'Calle' },
    { key: 'CALLE LARGA', label: 'Calle larga' },
    { key: 'CALLESELLE', label: 'Calleselle' },
    { key: 'CAMPAZZO', label: 'Campazzo' },
    { key: 'CAMPIELLO', label: 'Campiello' },
    { key: 'CAMPO', label: 'Campo' },
    { key: 'CANALE', label: 'Canale' },
    { key: 'CANTO', label: 'Canto' },
    { key: 'CANTONE', label: 'Cantone' },
    { key: 'CASALE', label: 'Casale' },
    { key: 'CASCINA', label: 'Cascina' },
    { key: 'CASELLA POSTALE', label: 'Casella postale' },
    { key: 'CAVALCAVIA', label: 'Cavalcavia' },
    { key: 'CAVONCELLO', label: 'Cavoncello' },
    { key: 'CAVONE', label: 'Cavone' },
    { key: 'CHIASSO', label: 'Chiasso' },
    { key: 'CIRCONVALLAZIONE', label: 'Circonvallazione' },
    { key: 'CONTRA\'', label: 'Contra\'' },
    { key: 'CONTRADA', label: 'Contrada' },
    { key: 'CORSO', label: 'Corso' },
    { key: 'CORTE', label: 'Corte' },
    { key: 'CORTICELLA', label: 'Corticella' },
    { key: 'CORTILE', label: 'Cortile' },
    { key: 'CORTINA', label: 'Cortina' },
    { key: 'COSTA', label: 'Costa' },
    { key: 'CROCEVIA', label: 'Crocevia' },
    { key: 'CROSERA', label: 'Crosera' },
    { key: 'CUPA', label: 'Cupa' },
    { key: 'CUPA VICINALE', label: 'Cupa vicinale' },
    { key: 'DARSENA', label: 'Darsena' },
    { key: 'DISCESA', label: 'Discesa' },
    { key: 'DISTACCO DI PIAZZA', label: 'Distacco di piazza' },
    { key: 'EMICICLO', label: 'Emiciclo' },
    { key: 'ERTA', label: 'Erta' },
    { key: 'FONDACO', label: 'Fondaco' },
    { key: 'FONDAMENTA', label: 'Fondamenta' },
    { key: 'FONDAMENTE NUOVE', label: 'Fondamente nuove' },
    { key: 'FONDO', label: 'Fondo' },
    { key: 'FORO', label: 'Foro' },
    { key: 'FOSSA', label: 'Fossa' },
    { key: 'FOSSO', label: 'Fosso' },
    { key: 'FRAZIONE', label: 'Frazione' },
    { key: 'GALLERIA', label: 'Galleria' },
    { key: 'GIARDINI', label: 'Giardini' },
    { key: 'GIRO', label: 'Giro' },
    { key: 'GRADINI', label: 'Gradini' },
    { key: 'GRADONI', label: 'Gradoni' },
    { key: 'GRANDE RACCORDO ANULARE', label: 'Grande raccordo anulare' },
    { key: 'INTERRATO', label: 'Interrato' },
    { key: 'ISOLA', label: 'Isola' },
    { key: 'LARGHETTO', label: 'Larghetto' },
    { key: 'LARGO', label: 'Largo' },
    { key: 'LISTA', label: 'Lista' },
    { key: 'LISTA VECCHIA', label: 'Lista vecchia' },
    { key: 'LOCALITA\'', label: 'Localita\'' },
    { key: 'LOGGE', label: 'Logge' },
    { key: 'LOGGETTA', label: 'Loggetta' },
    { key: 'LUNGADIGE', label: 'Lungadige' },
    { key: 'LUNGARGINE', label: 'Lungargine' },
    { key: 'LUNGARNO', label: 'Lungarno' },
    { key: 'LUNGO', label: 'Lungo' },
    { key: 'LUNGOLAGO', label: 'Lungolago' },
    { key: 'LUNGOMARE', label: 'Lungomare' },
    { key: 'LUNGOTEVERE', label: 'Lungotevere' },
    { key: 'LUNGOTORRENTE', label: 'Lungotorrente' },
    { key: 'MARITTIMA', label: 'Marittima' },
    { key: 'MARZARIA', label: 'Marzaria' },
    { key: 'MASSERIA', label: 'Masseria' },
    { key: 'MERCATI GENERALI', label: 'Mercati generali' },
    { key: 'MERCATO', label: 'Mercato' },
    { key: 'MERCERIE', label: 'Mercerie' },
    { key: 'MOLO', label: 'Molo' },
    { key: 'MONTE', label: 'Monte' },
    { key: 'MURAZZI', label: 'Murazzi' },
    { key: 'PALUDO', label: 'Paludo' },
    { key: 'PARCO', label: 'Parco' },
    { key: 'PASSAGGIO', label: 'Passaggio' },
    { key: 'PASSEGGIATA', label: 'Passeggiata' },
    { key: 'PASSO', label: 'Passo' },
    { key: 'PENDICE', label: 'Pendice' },
    { key: 'PENDINO', label: 'Pendino' },
    { key: 'PENNINATA', label: 'Penninata' },
    { key: 'PESCARIA', label: 'Pescaria' },
    { key: 'PIANO', label: 'Piano' },
    { key: 'PIAZZA', label: 'Piazza' },
    { key: 'PIAZZALE', label: 'Piazzale' },
    { key: 'PIAZZATA', label: 'Piazzata' },
    { key: 'PIAZZETTA', label: 'Piazzetta' },
    { key: 'PIAZZOLA', label: 'Piazzola' },
    { key: 'PISCINA', label: 'Piscina' },
    { key: 'PONTE', label: 'Ponte' },
    { key: 'PONTILE', label: 'Pontile' },
    { key: 'PORTA', label: 'Porta' },
    { key: 'PORTICATO', label: 'Porticato' },
    { key: 'PORTICI', label: 'Portici' },
    { key: 'PORTICO', label: 'Portico' },
    { key: 'PORTO', label: 'Porto' },
    { key: 'PRESSO', label: 'Presso' },
    { key: 'PROLUNGAMENTO', label: 'Prolungamento' },
    { key: 'QUADRIVIO', label: 'Quadrivio' },
    { key: 'QUARTIERE', label: 'Quartiere' },
    { key: 'RACCORDO', label: 'Raccordo' },
    { key: 'RAMO', label: 'Ramo' },
    { key: 'RAMPA', label: 'Rampa' },
    { key: 'RAMPANTE', label: 'Rampante' },
    { key: 'RAMPE', label: 'Rampe' },
    { key: 'REGIONE', label: 'Regione' },
    { key: 'RIALTO', label: 'Rialto' },
    { key: 'RIGASTE', label: 'Rigaste' },
    { key: 'RIO', label: 'Rio' },
    { key: 'RIO TERA\'', label: 'Rio tera\'' },
    { key: 'RIONE', label: 'Rione' },
    { key: 'RIPA', label: 'Ripa' },
    { key: 'RIPARTO', label: 'Riparto' },
    { key: 'RIVA', label: 'Riva' },
    { key: 'RIVALE', label: 'Rivale' },
    { key: 'RIVIERA', label: 'Riviera' },
    { key: 'ROTABILE', label: 'Rotabile' },
    { key: 'ROTONDA', label: 'Rotonda' },
    { key: 'RUA', label: 'Rua' },
    { key: 'RUE', label: 'Rue' },
    { key: 'RUGA', label: 'Ruga' },
    { key: 'RUGA GIUFFA', label: 'Ruga giuffa' },
    { key: 'RUGA VECCHIA', label: 'Ruga vecchia' },
    { key: 'RUGHETTA', label: 'Rughetta' },
    { key: 'SACCA', label: 'Sacca' },
    { key: 'SALITA', label: 'Salita' },
    { key: 'SALIZADA', label: 'Salizada' },
    { key: 'SALIZZADE', label: 'Salizzade' },
    { key: 'SBARCATOIO', label: 'Sbarcatoio' },
    { key: 'SCALA', label: 'Scala' },
    { key: 'SCALA PRIVATA', label: 'Scala privata' },
    { key: 'SCALE', label: 'Scale' },
    { key: 'SCALI', label: 'Scali' },
    { key: 'SCALINATA', label: 'Scalinata' },
    { key: 'SCALO MERCI', label: 'Scalo merci' },
    { key: 'SDRUCCIOLO', label: 'Sdrucciolo' },
    { key: 'SECCO', label: 'Secco' },
    { key: 'SESTIERE', label: 'Sestiere' },
    { key: 'SILOS', label: 'Silos' },
    { key: 'SITO', label: 'Sito' },
    { key: 'SOTTOPASSAGGIO', label: 'Sottopassaggio' },
    { key: 'SOTTOPORTICO', label: 'Sottoportico' },
    { key: 'SPADARIA', label: 'Spadaria' },
    { key: 'SPALTO', label: 'Spalto' },
    { key: 'STAZIONE', label: 'Stazione' },
    { key: 'STRADA', label: 'Strada' },
    { key: 'STRADA COMUNALE', label: 'Strada comunale' },
    { key: 'STRADA NUOVA', label: 'Strada nuova' },
    { key: 'STRADA PRIVATA', label: 'Strada privata' },
    { key: 'STRADA PROVINCIALE', label: 'Strada provinciale' },
    { key: 'STRADA STATALE', label: 'Strada statale' },
    { key: 'STRADA VECCHIA', label: 'Strada vecchia' },
    { key: 'STRADA VICINALE', label: 'Strada vicinale' },
    { key: 'STRADALE', label: 'Stradale' },
    { key: 'STRADELLO', label: 'Stradello' },
    { key: 'STRADETTA', label: 'Stradetta' },
    { key: 'STRADONE', label: 'Stradone' },
    { key: 'STRETTO', label: 'Stretto' },
    { key: 'STRETTOIA', label: 'Strettoia' },
    { key: 'STRETTOLA', label: 'Strettola' },
    { key: 'SUPPORTICO', label: 'Supportico' },
    { key: 'TONDO', label: 'Tondo' },
    { key: 'TRAGHETTO', label: 'Traghetto' },
    { key: 'TRATTO', label: 'Tratto' },
    { key: 'TRAVERSA', label: 'Traversa' },
    { key: 'TRAVERSA NUOVA', label: 'Traversa nuova' },
    { key: 'TRAVERSA PRIVATA', label: 'Traversa privata' },
    { key: 'TRAVERSA VICINALE', label: 'Traversa vicinale' },
    { key: 'VALLONE', label: 'Vallone' },
    { key: 'VARCO', label: 'Varco' },
    { key: 'VIA', label: 'Via' },
    { key: 'VIA COMUNALE', label: 'Via comunale' },
    { key: 'VIA LARGA', label: 'Via larga' },
    { key: 'VIA LUNGO', label: 'Via lunga' },
    { key: 'VIA NUOVA', label: 'Via nuova' },
    { key: 'VIA NUOVA', label: 'Via nuova' },
    { key: 'VIA PRIVATA', label: 'Via privata' },
    { key: 'VIA PROVINCIALE', label: 'Via provinciale' },
    { key: 'VIA ROTTA', label: 'Via rotta' },
    { key: 'VIA STORTA', label: 'Via storta' },
    { key: 'VIA VECCHIA', label: 'Via vecchia' },
    { key: 'VIA VICINALE', label: 'Via vicinale' },
    { key: 'VIADOTTO', label: 'Viadotto' },
    { key: 'VIALE', label: 'Viale' },
    { key: 'VIALE PRIVATO', label: 'Viale privato' },
    { key: 'VICO', label: 'Vico' },
    { key: 'VICO LARGO', label: 'Vico largo' },
    { key: 'VICO LUNGO', label: 'Vico lungo' },
    { key: 'VICO NUOVO', label: 'Vico nuovo' },
    { key: 'VICO PRIVATO', label: 'Vico privato' },
    { key: 'VICO ROTTO', label: 'Vico rotto' },
    { key: 'VICO STORTO', label: 'Vico storto' },
    { key: 'VICO VECCHIO', label: 'Vico vecchio' },
    { key: 'VICOLETTO', label: 'Vicoletto' },
    { key: 'VICOLO', label: 'Vicolo' },
    { key: 'VICOLO LARGO', label: 'Vicolo largo' },
    { key: 'VICOLO LUNGO', label: 'Vicolo lungo' },
    { key: 'VICOLO NUOVO', label: 'Vicolo nuovo' },
    { key: 'VICOLO PRIVATO', label: 'Vicolo privato' },
    { key: 'VICOLO ROTTO', label: 'Vicolo rotto' },
    { key: 'VICOLO STORTO', label: 'Vicolo storto' },
    { key: 'VICOLO VECCHIO', label: 'Vicolo vecchio' },
    { key: 'VILLA', label: 'Villa' },
    { key: 'VILLAGGIO', label: 'Villaggio' },
    { key: 'VIOTTOLO', label: 'Viottolo' },
    { key: 'VIUZZO', label: 'Viuzzo' },
    { key: 'VOCABOLO', label: 'Vocabolo' },
    { key: 'VOLTA', label: 'Volta' },
    { key: 'VOLTO', label: 'Volto' },
    { key: 'ZONA', label: 'Zona' },
    { key: 'ZONA INDUSTRIALE', label: 'Zona industriale' }
]